'use strict';

const libPictView = require('pict-view');
const libConfigs = require('../documents/DocumentThroughput-Configs.js');
const html = String.raw;

/**
 * DocumentThroughput — the thin standalone screen (#/DocumentThroughput[/:Type]) that hosts the reusable document-approval
 * throughput dashboard. The route's :Type selects the per-type config (defaults to Inspection-Dossier); the
 * DocumentThroughput provider paints into #DocumentThroughput-Host. Full browser width via Dashboard Mode.
 * See [[DocumentThroughput-Provider.js]] and [[DocumentThroughput-Configs.js]].
 */
class DocumentThroughputView extends libPictView
{
	get provider() { return this.pict.providers['DocumentThroughput']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			const tmpConfig = libConfigs.resolveConfig(this._routeType || '');
			// paint the header from the config
			try
			{
				const ca = this.pict.ContentAssignment;
				ca.assignContent('#DocumentThroughput-Title', `<i class="${tmpConfig.Icon || 'fas fa-file-signature'}"></i> ${tmpProvider._esc(tmpConfig.Title || 'Document throughput')}`);
				ca.assignContent('#DocumentThroughput-Sub', tmpProvider._esc(tmpConfig.Subtitle || ''));
			}
			catch (e) { /* */ }
			tmpProvider.renderInto('#DocumentThroughput-Host', tmpConfig);
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = DocumentThroughputView;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentThroughput',
	DefaultRenderable: 'DocumentThroughputWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.dtp-page { padding: 1.25rem 2rem 2rem; }
		.dtp-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.dtp-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.dtp-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; max-width: 60rem; }
	`,

	Templates:
	[
		{
			Hash: 'DocumentThroughput-Template',
			Template: html`
				<section class="section dtp-page">
					<h1 class="dtp-page-h" id="DocumentThroughput-Title"><i class="fas fa-file-signature"></i> Document throughput</h1>
					<p class="dtp-page-sub" id="DocumentThroughput-Sub"></p>
					<div id="DocumentThroughput-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'DocumentThroughputWrap',
			TemplateHash: 'DocumentThroughput-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
